import { render, staticRenderFns } from "./NativeHeader.vue?vue&type=template&id=458cf983&scoped=true"
import script from "./NativeHeader.vue?vue&type=script&lang=js"
export * from "./NativeHeader.vue?vue&type=script&lang=js"
import style0 from "./NativeHeader.vue?vue&type=style&index=0&id=458cf983&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458cf983",
  null
  
)

export default component.exports